import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/index.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import VueAwesomeSwiper from "vue-awesome-swiper"; //平移轮播
Vue.use(VueAwesomeSwiper)

import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(element)


Vue.config.productionTip = false

import AXIOS from 'axios'
Vue.prototype.$axios = AXIOS

let url = "http://82.156.125.76:5000";


import ArrowPointer from './components/ArrowPointer';

// 初始化Vue实例
const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

// 在Vue实例挂载后初始化光标
if (process.env.NODE_ENV !== 'production') { // 仅在开发环境启用
    document.addEventListener('DOMContentLoaded', () => {
        const cursor = new ArrowPointer();
        document.onmousemove = function (event) {
            cursor.move(event);
        };
        document.ontouchmove = function (event) {
            cursor.move(event.touches[0]);
        };
        document.onclick = function () {
            if (typeof cursor.click === 'function') {
                cursor.click();
            }
        };
    });
}
